import { format, isAfter, startOfWeek } from 'date-fns';
import { getLocale } from './locales';

export const getFormattedDate = (
  date: Date,
  formatString: string,
  languageCode: string
): string => {
  const locale = getLocale(languageCode);
  return format(date, formatString, { locale });
};

export function dateFormatToBackend(dateTime: Date): string {
  return format(dateTime, 'yyyy-M-d');
}

export function formatDateOnly(
  date: Date,
  format: string,
  languageCode: string
): string {
  let formatString = 'MMM d, yyyy';
  if (format === 'l, d M Y H:i') {
    formatString = 'eeee, d MMM yyyy';
  }
  return getFormattedDate(date, formatString, languageCode);
}

export function formatDateAndTime(
  date: Date,
  format: string,
  languageCode: string
): string {
  let formatString = 'MMM d, yyyy h:mm a';
  if (format === 'l, d M Y H:i') {
    formatString = 'eeee, d MMM yyyy H:mm';
  }
  return getFormattedDate(date, formatString, languageCode);
}

export const isFutureWeek = (date: Date) => {
  const weekStart = startOfWeek(date, { weekStartsOn: 1 });
  const currentWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });

  return isAfter(weekStart, currentWeekStart);
};
